export default {_name:'grid.form.section',module:'Card/Form',view:'Element/Section',options:{component:'section',md:12,block:{md:7,lg:7,xl:7}}}